import React, { useState, useEffect, useCallback } from 'react';
import { Dialog, message } from '@tencent/spaui';
import copy from 'copy-to-clipboard';
import { RPCFactory } from '../../../../utils/RequestUtil';

const Title = () => {
  return (
    <div className="leads-auth-title">
      <h2 style={{ fontSize: '18px' }}>选择线索来源</h2>
      <p className="text-weak">完成配置后，可实时接收线索推送，统一管理</p>
    </div>
  );
};

const Card = ({ children }) => {
  if (!children) {
    return (
      <div className="leads-auth-card no-data">
        <p className="no-data-title">敬请期待</p>
        <p className="no-data-title-sub">更多平台对接中，敬请期待</p>
      </div>
    );
  }
  return (
    <div className="leads-auth-card">
      { children }
    </div>
  );
};

const Byte = () => {
  const img = 'https://bkimg.cdn.bcebos.com/pic/a50f4bfbfbedab64034ff52fb97cb8c379310b55b080';
  const strongStyle = {
    fontSize: '18px',
    fontWeight: 'bold',
    lineHeight: 2,
  };
  const [pushUrl, setPushUrl] = useState('');
  const [show, setShow] = useState(false);

  const getPushUrl = useCallback(() => {
    RPCFactory.leadsSetting.getLeadsPushUrl({ type: 1 })
      .done((data) => {
        if (typeof data !== 'string' || !data) throw new Error('Leads push url not found.')
        setPushUrl(data);
      })
      .fail(console.error);
  }, []);

  const handleOpen = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleCopy = (e) => {
    e.preventDefault();
    if (!pushUrl) {
      message.error('推送url获取失败，请稍后再试');
      getPushUrl();
      return;
    }
    if (copy(pushUrl)) {
      message.success('推送url复制成功');
    }
  };

  useEffect(getPushUrl, [getPushUrl]);

  return (
    <div className="auth-card-byte">
      <img
        src={img}
        alt="byte dance"
        onClick={handleOpen}
        style={{ width: '100%', marginTop: -28 }}
      />
      <Dialog
        type="normal"
        title="配置线索推送"
        style={{ width: 500 }}
        cancelButton={null}
        show={show}
        onSubmit={handleClose}
        onClose={handleClose}
        footerStyle={{ textAlign: 'center' }}
      >
        <p style={{ marginTop: -15 }}>配置前先阅读<a className="underline" target="_blank" href="https://leads.gdtimg.com/qzone/biz/gdt/leads-cdn/doc/zijie_leads_helper.pdf" rel="noreferrer">配置说明文档</a></p>
        <br />
        <p style={strongStyle}>1、获取配置推送地址，<a className="underline" href="#" onClick={handleCopy}>复制推送url</a></p>
        <p style={strongStyle}>2、在飞鱼创建推送规则，<a className="underline" target="_blank" href="https://feiyu.oceanengine.com/pc/crm/feiyu/management/clue-push-rule" rel="noreferrer">登录飞鱼</a></p>
      </Dialog>
    </div>
  );
};

const Auth = () => {
  return (
    <div className="card leads-auth" style={{ padding: '24px 30px' }}>
      <Title />
      <div className="leads-auth-body">
        <Card><Byte /></Card>
        <Card></Card>
      </div>
    </div>
  );
};

export default Auth;
